import Section from '../Section';
import Parallax from '../global/Parallax';
import QuickAdd from '../global/QuickAdd';

export default class CollectionListSection extends Section {

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.parallax = new Parallax(theme, element.parentNode);
    this.quickAddButtons = new QuickAdd(theme, element);
  }
}
